import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=6ff7fb28&"
import script from "./FormQuestion.vue?vue&type=script&lang=js&"
export * from "./FormQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=6ff7fb28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports